import { FC, ReactNode } from 'react';
import { Radio } from 'rsuite';
import classnames from 'classnames';
import styles from './radioCell.module.scss';

interface RadioCellProps {
  value: string;
  label?: ReactNode;
  customRight?: ReactNode;
  customBottom?: ReactNode;
  className?: string;
  disabled?: boolean;
}

export const RadioCell: FC<RadioCellProps> = ({
  value = '',
  label = null,
  customRight,
  customBottom,
  className = '',
  disabled = false,
}) => {
  return (
    <div className={classnames(styles.RadioCell, className)}>
      <div className='mb-1 flex items-center'>
        <Radio value={value} disabled={disabled}>
          {label}
        </Radio>
        {customRight}
      </div>
      {customBottom && (
        <div className={styles.customBottom}>{customBottom}</div>
      )}
    </div>
  );
};
